/* eslint-disable no-useless-escape */

const nonNumericReg = /[^0-9]/gi;
const koreanReg = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g;
const businessLicenseNumberReg = /^([0-9]{3})-?([0-9]{2})-?([0-9]{5})$/; // NOTE: from Chanel
const nicknameReg = /^[a-zA-Z가-힣0-9]*$/;

/**
 * @desc 휴대폰 번호 숫자로만 (하이픈 없이)
 * 01012345678 (O)
 * 010-1234-5678 (X)
 */
const PHONE_NUMBER_ONLY_DIGITS = /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/;

/**
 * @desc 이메일 형식
 */
const EMAIL =
    /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}(.*)/;

/**
 * @desc Numeric String
 */
const NUMBER_ONLY = /^[0-9]*$/;

export {
    nonNumericReg,
    koreanReg,
    businessLicenseNumberReg,
    nicknameReg,
    PHONE_NUMBER_ONLY_DIGITS,
    EMAIL,
    NUMBER_ONLY,
};
